/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".header[_ngcontent-%COMP%]{background-color:#fff}.hx-preferences[_ngcontent-%COMP%]{background-color:rgba(255,255,255,.8);padding:10px 4px 0}.hx-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{background-color:rgba(255,255,255,.8)}.hx-table[_ngcontent-%COMP%]   tfoot[_ngcontent-%COMP%]{border:0 solid #fff}.tiny[_ngcontent-%COMP%]{font-size:70%}"];
export { styles as styles };
